import StationWithDateTimesType from "@SearchResults/types/station/StationWithDateTimes.type";

/**
 * Returns datetime string from station object
 */
export default function getDateTimeStringFromStation(station: StationWithDateTimesType) {
    return `${station?.departureDate}T${station?.departureTime}`
}